module.exports = __webpack_public_path__ + "static/media/599.7554(29).30cba3c1.pdf";